// src/firebase.js
import { initializeApp } from "firebase/app";
import {
  getAuth,
  setPersistence,
  browserLocalPersistence,
} from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";

export const firebaseConfig = {
  apiKey: "AIzaSyDJ13PIa0YIpIotG0-RMXTcnTq5TS9CIfQ",
  authDomain: "accentsquotationapp.firebaseapp.com",
  projectId: "accentsquotationapp",
  storageBucket: "accentsquotationapp.firebasestorage.app",
  messagingSenderId: "366456468963",
  appId: "1:366456468963:web:b6581b637f64d4cfd35cd6",
};

export const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
setPersistence(auth, browserLocalPersistence);

export const db = getFirestore(app);

export const storage = getStorage(app);

export const functions = getFunctions(app, "asia-south1");
